<template>
    <div class="setItems__item setItems__item--shrinked">{{ quantity }} x {{ name }}</div>
</template>

<script>
    export default {
        props: ['product'],
        computed: {
            quantity: function () {
                return this.product.quantity;
            },
            name: function () {
                return this.product.name;
            }
        }
    };
</script>